import * as COMPANY_API from '@/api/company'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getPagedCompanies ({ commit }, data) {
      if (!data.tags && data.query === '') {
        let response = await COMPANY_API.getPagedCompanies(data.page, data.limit)
        return response.data
      } else {
        let response = await COMPANY_API.queryCompanies(data.query, data.tags, data.page, data.limit)
        return response.data
      }
    },
    async addCompany ({ commit }, data) {
      let response = await COMPANY_API.addCompany(data)
      return response.data
    },
    async updateSingleCompany ({ commit }, data) {
      let response = await COMPANY_API.updateSingleCompany(data.id, data.data)
      return response.data
    },
    async deleteSingleCompany ({ commit }, id) {
      let response = await COMPANY_API.deleteSingleCompany(id)
      return response.data
    }
  }
}
